// extracted by mini-css-extract-plugin
export default {"container":"style_container__hP0Rc","subtract":"style_subtract__G-4np","add":"style_add__3TUeY","value":"style_value__EYUEt"};